import { call, put, select, takeLatest } from "redux-saga/effects";
import { FETCH_NEWS_REQUEST, fetchNewsFailure, fetchNewsSuccess } from "../../actions/opportunities/newsActions";
import qs from 'qs';
import iq_api_v2 from "../../../../services/iqApiV2";

async function findNewsData(opportunityId = "") {
    const data = qs.stringify({
      opportunity_id: opportunityId,
    });
  
    try {
      const response = await iq_api_v2.post("/opportunities/get_news?"+data, '')
      let newsData = {};
      newsData = response?.data;
      newsData.sort((a, b) => {
        const dateA = a.date ? new Date(a.date) : new Date(0); // fallback to epoch if date is missing
        const dateB = b.date ? new Date(b.date) : new Date(0);
        return dateB - dateA;
      });

      // console.log("NEWS DATA: "+JSON.stringify(newsData))
      return newsData;
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
    }
  }

// Worker Saga
function* fetchNewsSaga() {
  try {
    const payload = yield select(
      (state) => state?.newsReducer?.payload
    );
    const { opportunityId = "" } = payload;
    const data = yield call(
        findNewsData,
        opportunityId
    );
    yield put(fetchNewsSuccess(data));
  } catch (error) {
    yield put(fetchNewsFailure(error.message));
  }
}

// Watcher Saga
export function* watchNewsData() {
  yield takeLatest(FETCH_NEWS_REQUEST, fetchNewsSaga);
}
